/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DateFilterEnum = "all_time" | "last_month" | "last_seven_days" | "last_three_month" | "last_year" | "today" | "%future added value";
export type FeedItemListTypeEnum = "all" | "config_settings" | "contacts" | "containers" | "customs_types" | "default_folders" | "document_templates" | "document_types" | "email_templates" | "languages" | "miscellaneous_settings" | "ports" | "rate_cards" | "roles" | "shipment_types" | "shipments" | "shipping_lines" | "templates" | "vessels" | "voyages" | "%future added value";
export type TimelinePaginationQueryVariables = {
    after?: number | null;
    dateFilter: DateFilterEnum;
    first?: number | null;
    group?: string | null;
    handle?: string | null;
    parentAbsoluteSlug?: string | null;
    slug?: string | null;
    type?: FeedItemListTypeEnum | null;
};
export type TimelinePaginationQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"Timeline_queryData">;
};
export type TimelinePaginationQuery = {
    readonly response: TimelinePaginationQueryResponse;
    readonly variables: TimelinePaginationQueryVariables;
};



/*
query TimelinePaginationQuery(
  $after: Int
  $dateFilter: DateFilterEnum!
  $first: Int
  $group: String
  $handle: String
  $parentAbsoluteSlug: String
  $slug: String
  $type: FeedItemListTypeEnum
) {
  ...Timeline_queryData
}

fragment FeedAttachments_data on AttachmentConnection {
  nodes {
    slug
    ...SmallAttachment_attachment
  }
}

fragment FeedImages_data on ImageConnection {
  edges {
    node {
      url
      shape
      overlay
    }
  }
}

fragment FeedItem_data on FeedItem {
  slug
  entity
  title
  titleImage {
    url
  }
  happenedAt
  images {
    edges {
      node {
        url
      }
    }
    ...FeedImages_data
  }
  contentLines {
    key
    text
  }
  attachments {
    nodes {
      slug
    }
    ...FeedAttachments_data
  }
  keyFields {
    key
    ...KeyField_data
  }
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment SmallAttachment_attachment on Attachment {
  url
  name
  contentType
  previewUrl
}

fragment Timeline_queryData on ApplicationQuery {
  feedItemList(handle: $handle, slug: $slug, type: $type, group: $group, parentAbsoluteSlug: $parentAbsoluteSlug, dateFilter: $dateFilter, first: $first, after: $after) {
    feedItems {
      slug
      dayLabel
      ...FeedItem_data
      id
    }
    totalCount
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateFilter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "group"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "handle"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parentAbsoluteSlug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "type"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimelinePaginationQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Timeline_queryData"
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimelinePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "dateFilter",
            "variableName": "dateFilter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          },
          {
            "kind": "Variable",
            "name": "group",
            "variableName": "group"
          },
          {
            "kind": "Variable",
            "name": "handle",
            "variableName": "handle"
          },
          {
            "kind": "Variable",
            "name": "parentAbsoluteSlug",
            "variableName": "parentAbsoluteSlug"
          },
          {
            "kind": "Variable",
            "name": "slug",
            "variableName": "slug"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "FeedItemList",
        "kind": "LinkedField",
        "name": "feedItemList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeedItem",
            "kind": "LinkedField",
            "name": "feedItems",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dayLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "titleImage",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "happenedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageConnection",
                "kind": "LinkedField",
                "name": "images",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shape",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "overlay",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SemanticString",
                "kind": "LinkedField",
                "name": "contentLines",
                "plural": true,
                "selections": (v4/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AttachmentConnection",
                "kind": "LinkedField",
                "name": "attachments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Attachment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contentType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewUrl",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyField",
                "kind": "LinkedField",
                "name": "keyFields",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "value",
                    "plural": true,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc49dd17daec1c2e71e67232e9af47d3",
    "id": null,
    "metadata": {},
    "name": "TimelinePaginationQuery",
    "operationKind": "query",
    "text": "query TimelinePaginationQuery(\n  $after: Int\n  $dateFilter: DateFilterEnum!\n  $first: Int\n  $group: String\n  $handle: String\n  $parentAbsoluteSlug: String\n  $slug: String\n  $type: FeedItemListTypeEnum\n) {\n  ...Timeline_queryData\n}\n\nfragment FeedAttachments_data on AttachmentConnection {\n  nodes {\n    slug\n    ...SmallAttachment_attachment\n  }\n}\n\nfragment FeedImages_data on ImageConnection {\n  edges {\n    node {\n      url\n      shape\n      overlay\n    }\n  }\n}\n\nfragment FeedItem_data on FeedItem {\n  slug\n  entity\n  title\n  titleImage {\n    url\n  }\n  happenedAt\n  images {\n    edges {\n      node {\n        url\n      }\n    }\n    ...FeedImages_data\n  }\n  contentLines {\n    key\n    text\n  }\n  attachments {\n    nodes {\n      slug\n    }\n    ...FeedAttachments_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment SmallAttachment_attachment on Attachment {\n  url\n  name\n  contentType\n  previewUrl\n}\n\nfragment Timeline_queryData on ApplicationQuery {\n  feedItemList(handle: $handle, slug: $slug, type: $type, group: $group, parentAbsoluteSlug: $parentAbsoluteSlug, dateFilter: $dateFilter, first: $first, after: $after) {\n    feedItems {\n      slug\n      dayLabel\n      ...FeedItem_data\n      id\n    }\n    totalCount\n  }\n}\n"
  }
};
})();
(node as any).hash = '192fe870bd341a781c20544d1b47ccee';
export default node;
